import React from "react";
import ChevronXs from "../../icons/chevron-xs.icon";
import "./number-input-with-controls.component.scss";
import PriceInput from "../price-input";
import cn from "../../../Utils/class-names.utils";

interface NumberInputWithControlsProps {
  label?: string;
  id: string;
  value: string | number;
  currencySymbol?: string;
  onChange: (value: string | number) => void;
  onIncrement: () => void;
  onDecrement: () => void;
  outputText?: string;
  inputType?: "number" | "text";
  min?: string;
  wrapperStyle?: React.CSSProperties;
  ariaLabel?: string;
  className?: string;
  wrapperClassName?: string;
  prefix?: string;
  postfix?: string;
  disabled?: boolean;
}

const NumberInputWithControls: React.FC<NumberInputWithControlsProps> = ({
  label,
  id,
  value,
  currencySymbol,
  onChange,
  onIncrement,
  onDecrement,
  outputText,
  min,
  wrapperStyle,
  ariaLabel,
  className,
  wrapperClassName,
  prefix,
  postfix,
  disabled = false,
}) => {
  return (
    <div className={cn("number-input-with-controls", className)}>
      <div className="units-row">
        <div className="units-inner">
          <div className="units-inner">
            <div className="units-control-row">
              {label && (
                <label htmlFor={id} className="units-label">
                  <span>
                    {label}
                  </span>
                </label>
              )}

              <div className={cn("units-input-wrapper", wrapperClassName, { "disabled": disabled })} style={wrapperStyle}>
                {prefix && (
                  <div className="units-input-prefix">
                    {prefix}
                  </div>
                )}
                <div className="units-input-content">
                  <PriceInput
                    id={id}
                    value={value}
                    onChange={onChange}
                    min={min}
                    className="units-input"
                    aria-label={ariaLabel || label}
                    prefix={currencySymbol}
                    postfix={postfix}
                    disabled={disabled}
                  />
                </div>

                <div className="units-controls">
                  <button
                    type="button"
                    onClick={onIncrement}
                    className="units-control-btn"
                    aria-label={`Increment ${label?.toLowerCase()}`}
                    disabled={disabled}
                  >
                    <div className="icon-wrapper-inner">
                      <ChevronXs style={{ transform: 'rotate(180deg)' }} />
                    </div>
                  </button>

                  <button
                    type="button"
                    onClick={onDecrement}
                    className="units-control-btn"
                    aria-label={`Decrement ${label?.toLowerCase()}`}
                    disabled={disabled}
                  >
                    <div className="icon-wrapper-inner">
                      <ChevronXs />
                    </div>
                  </button>
                </div>
              </div>

              {outputText && (
                <div className="units-output-wrapper">
                  <output
                    htmlFor={id}
                    className="units-output"
                    aria-live="polite"
                  >
                    {outputText}
                  </output>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NumberInputWithControls;

